import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'output', 'hint']
  static values = {
    max: { type: Number, default: 100 }
  }

  static classes = ['error']

  connect () {
    this.update()
  }

  update () {
    this.outputTarget.textContent = `${this.count}`

    if (this.hasErrorClass && this.hasHintTarget) {
      this.showError = this.count > this.maxValue
      this.hintTarget.classList.toggle(this.errorClass, this.showError)
    }
  }

  get count () {
    return this.inputTarget.value.length
  }
}
